import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_SUBSCRIPTIONS_FOR = defineFcm('enable_subscriptions_for')
	.asBoolean()
	.withDefault(false)
	.toConfig();
